import _plugin_vue_export_helper_default from "../../_virtual/_plugin-vue_export-helper.js";
import ScalarIcon_vue_vue_type_script_setup_true_lang_default from "./ScalarIcon.vue_vue_type_script_setup_true_lang.js";
/* empty css                                                               */
//#region src/components/ScalarIcon/ScalarIcon.vue
var ScalarIcon_default = /*#__PURE__*/ _plugin_vue_export_helper_default(ScalarIcon_vue_vue_type_script_setup_true_lang_default, [["__scopeId", "data-v-b651bb23"]]);
//#endregion
export { ScalarIcon_default as default };

//# sourceMappingURL=ScalarIcon.vue.js.map